import { render } from "./external-link.svg?vue&type=template&id=531d5860"
const script = {}
script.render = render

export default script